var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.13H1.5945C2.1 15.4845 4.9755 18 9.51 18C10.443 18 11.2605 17.898 11.9985 17.7225V15.7725C11.2725 15.951 10.431 16.0275 9.51 16.0275C6.36 16.0275 4.3275 14.2305 3.8475 11.1315H9.873V9.73952H3.7455V8.33552C3.7455 8.17052 3.7455 8.00702 3.7575 7.84202H9.8745V6.45152H3.927C4.509 3.60452 6.5055 1.97402 9.5115 1.97402C10.4325 1.97402 11.274 2.04902 12 2.23952V0.291022C11.1861 0.0892975 10.35 -0.00848135 9.5115 2.2131e-05C5.1195 2.2131e-05 2.2815 2.35352 1.6455 6.45002H0V7.84202H1.515V9.73952H0V11.1315V11.13Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.a58e753cd0b25acc38c58e55e091c5b7.svg";
export { ForwardRef as ReactComponent };